module.exports = __webpack_public_path__ + "img/widgettrust-2.1eb1cddd.png";